import { Navigate, Route } from 'react-router-dom'
import { RouteNamesAuth, RouteNamesGeneral, RouteNamesNonAuth } from './enum'

//Non Auth Routes
import { NoAuthRoutes } from './noAuthRoutes'
import { Login } from 'pages/Login'
import { Register } from 'pages/Register'

//Auth Routes
import { AuthRoutes } from './authRoutes'
import { Dashboard } from 'pages/Dashboard'
import { Product } from 'pages/Product'
import { Documents } from 'pages/Documents'
import { Extract } from 'pages/Extract'
import { Claims } from 'pages/Claims'
import { ProfileBroker } from 'pages/ProfileBroker'
import { Profile } from 'pages/Profile'
import {
  Certificates,
  PastTrainings,
  Trainings,
  Tutorials,
} from 'pages/Trainings'
import { Quotations } from 'pages/Quotations'
import { Quotation } from 'pages/Quotation'
import { Simulators } from 'pages/Simulators'
import { Policies } from 'pages/Policies'
import { Policy } from 'pages/Policy'
import { Invoices } from 'pages/Invoices'
import { Invoice } from 'pages/Invoice'
import { ProtectedRoute } from 'components/Private'
import { ProductCategories } from 'pages/Admin/ProductCategories'
import { BackOfficeProducts } from 'pages/Admin/Products'
import { BackOfficeProduct } from 'pages/Admin/Product'
import { BackOfficeCampaigns } from 'pages/Admin/Campaigns'
import { BackOfficeCampaign } from 'pages/Admin/Campaign'
import { BackOfficeWebisodes } from 'pages/Admin/Webisodes'
import { BackOfficeWebisode } from 'pages/Admin/Webisode'
import { AdminDashboard } from 'pages/Admin/Dashboard'
import { BackofficeTrainings } from 'pages/Admin/Trainings'
import { BackofficeTraining } from 'pages/Admin/Training'
import { BackofficeSliders } from 'pages/Admin/Sliders'
import { BackofficePages } from 'pages/Admin/Pages'
import { BackofficePage } from 'pages/Admin/Page'
import { BackofficeSettings } from 'pages/Admin/Settings'
import { BackofficeBrokers } from 'pages/Admin/Brokers'
import { BackofficeBroker } from 'pages/Admin/Broker'
import { Campaigns } from 'pages/Campaigns'
import { Page } from 'pages/Page'
import { RegisterUser } from 'pages/RegisterUser'
import { ResetPassword } from 'pages/ResetPassword'
import { RequestNewPassword } from 'pages/RequestNewPassword'
import { TwoFA } from 'pages/TwoFA'
import { Maintenance } from 'pages/Maintenance'
import { NoPermission } from 'pages/NoPermission'
import { Claim } from 'pages/Claim'
import { BackOfficeSimulator } from 'pages/Admin/Simulator'

export const noAuthRoutes = (
  <Route element={<NoAuthRoutes />}>
    <Route
      path={RouteNamesGeneral.HOME}
      element={<Navigate to={RouteNamesNonAuth.LOGIN} replace />}
    />
    <Route path={RouteNamesNonAuth.LOGIN} element={<Login />} />
    <Route path={RouteNamesNonAuth.TWO_FA} element={<TwoFA />} />
    <Route
      path={RouteNamesNonAuth.RESET_PASSWORD}
      element={<ResetPassword />}
    />
    <Route path={RouteNamesNonAuth.REGISTER} element={<Register />} />
    <Route path={RouteNamesNonAuth.REGISTER_USER} element={<RegisterUser />} />
    <Route
      path={RouteNamesNonAuth.REQUEST_NEW_PASSWORD}
      element={<RequestNewPassword />}
    />
    <Route path={RouteNamesNonAuth.MAINTENANCE} element={<Maintenance />} />
    <Route path={RouteNamesNonAuth.SAFE_LOGIN} element={<Login />} />
  </Route>
)

export const authRoutes = (
  <Route element={<AuthRoutes />}>
    <Route element={<ProtectedRoute />}>
      <Route path={RouteNamesAuth.DASHBOARD} element={<Dashboard />} />
      <Route path={RouteNamesAuth.CAMPAIGNS} element={<Campaigns />} />
      <Route path={RouteNamesAuth.PRODUCT} element={<Product />} />
      <Route path={RouteNamesAuth.SIMULATOR} element={<Simulators />} />
      <Route path={RouteNamesAuth.DOCUMENTS} element={<Documents />} />
      <Route path={RouteNamesAuth.EXTRACTS} element={<Extract />} />
      <Route path={RouteNamesAuth.CLAIMS_PROCESS} element={<Page />} />
      <Route path={RouteNamesAuth.CLAIMS} element={<Claims />} />
      <Route path={RouteNamesAuth.CLAIM} element={<Claim />} />
      <Route path={RouteNamesAuth.PROFILE_BROKER} element={<ProfileBroker />} />
      <Route path={RouteNamesAuth.PROFILE} element={<Profile />} />
      <Route path={RouteNamesAuth.PAYMENTS} element={<Page />} />
      <Route path={RouteNamesAuth.TRAININGS} element={<Trainings />} />
      <Route path={RouteNamesAuth.PAST_TRAININGS} element={<PastTrainings />} />
      <Route path={RouteNamesAuth.TUTORIALS} element={<Tutorials />} />
      <Route path={RouteNamesAuth.CERTIFICATES} element={<Certificates />} />
      <Route path={RouteNamesAuth.QUOTATIONS} element={<Quotations />} />
      <Route path={RouteNamesAuth.QUOTATION_DETAILS} element={<Quotation />} />
      <Route path={RouteNamesAuth.POLICIES} element={<Policies />} />
      <Route path={RouteNamesAuth.POLICY_DETAILS} element={<Policy />} />
      <Route path={RouteNamesAuth.INVOICES} element={<Invoices />} />
      <Route path={RouteNamesAuth.INVOICE_DETAILS} element={<Invoice />} />
      <Route
        path={RouteNamesAuth.BACKOFFICE_DASHBOARD}
        element={<AdminDashboard />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_PRODUCT_CATEGORIES}
        element={<ProductCategories />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_PRODUCTS}
        element={<BackOfficeProducts />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_PRODUCT_DETAILS}
        element={<BackOfficeProduct />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_PRODUCT_SIMULATOR}
        element={<BackOfficeSimulator />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_CAMPAIGNS}
        element={<BackOfficeCampaigns />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_CAMPAIGN_DETAILS}
        element={<BackOfficeCampaign />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_WEBISODES}
        element={<BackOfficeWebisodes />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_WEBISODE_DETAILS}
        element={<BackOfficeWebisode />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_TRAININGS}
        element={<BackofficeTrainings />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_TRAINING_DETAILS}
        element={<BackofficeTraining />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_SLIDERS}
        element={<BackofficeSliders />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_PAGES}
        element={<BackofficePages />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_PAGE_DETAILS}
        element={<BackofficePage />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_BROKERS}
        element={<BackofficeBrokers />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_BROKER_DETAILS}
        element={<BackofficeBroker />}
      />
      <Route
        path={RouteNamesAuth.BACKOFFICE_SETTINGS}
        element={<BackofficeSettings />}
      />

      <Route
        path={RouteNamesGeneral.NOT_FOUND}
        element={<Navigate to={RouteNamesAuth.DASHBOARD} replace />}
      />
      <Route path={RouteNamesAuth.NO_PERMISSION} element={<NoPermission />} />
    </Route>
  </Route>
)
